import { ClassProperties } from 'types/utils'

import { SampledInstrumentType } from '@utils/nf-webaudio/sampled-instrument'

export type PartType = ClassProperties<Part>
/**
 * A Part represents a specification of a single instrumental part in the score.  It may be
 * associated with any number of consecutive Staff objects for grand-staff instruments.
 */
export default class Part {
  constructor(id = '') {
    this.id = id
    /** Full descriptive name of this part. */
    this.name = ''
    /** Abbreviated descriptive name. */
    this.shortName = ''

    /** relative URI of instrument within instrument library. */
    this.instrumentUri = ''

    /** URI of instrument library, if not the standard library. */
    this.libraryLocation = null

    /** The General MIDI instrument index. */
    this.midiPatch = 0

    /** Performance gain in dB. */
    this.gain = 0

    /** Pan ranging from -1 to +1, center = 0. */
    this.pan = 0

    /** Muting flag for performance */
    this.muted = false

    /** Cached web audio synthesizer.  Untyped, because the class is defined in JS. */
    this.synthesizer = null
  }

  get id(): string {
    return this.id
  }

  set id(val: string) {
    this.id = val
  }

  get name(): string {
    return this.name
  }

  set name(val: string) {
    this.name = val
  }

  get instrumentUri(): string {
    return this.instrumentUri
  }

  set instrumentUri(val: string) {
    this.instrumentUri = val
  }

  get shortName(): string {
    return this.shortName
  }

  set shortName(val: string) {
    this.shortName = val
  }

  get midiPatch(): number {
    return this.midiPatch
  }

  set midiPatch(val: number) {
    this.midiPatch = val
  }

  get libraryLocation(): string | null {
    return this.libraryLocation
  }

  set libraryLocation(val: string | null) {
    this.libraryLocation = val
  }

  get gain(): number {
    return this.gain
  }

  set gain(val: number) {
    this.gain = val
  }

  get pan(): number {
    return this.pan
  }

  set pan(val: number) {
    this.pan = val
  }

  get muted(): boolean {
    return this.muted
  }

  set muted(val: boolean) {
    this.muted = val
  }

  get synthesizer(): SampledInstrumentType | null {
    return this.synthesizer
  }

  set synthesizer(val: SampledInstrumentType | null) {
    this.synthesizer = val
  }
}
